export const USER_WAY_PROVIDER = 'UserWay';
export const USER_WAY_SERVICE_TYPE = 'ADA';
